<template>
  <Head :title="`Join ${company.name}`" />
  <div
    class="from-navy-50 to-navy-100 relative flex min-h-screen items-center justify-center bg-gradient-to-br via-neutral-50 px-4 py-12 sm:px-6 lg:px-8"
  >
    <div
      class="from-navy-500/5 absolute inset-0 bg-gradient-to-br to-green-500/10"
    ></div>

    <div class="relative z-10 w-full max-w-md">
      <div class="rounded-2xl bg-white p-8 shadow-xl">
        <div class="mb-8 text-center">
          <img
            src="/assets/trellis-logo.png"
            alt="Trellis Closings"
            class="mx-auto mb-2 h-12 w-auto"
          />
        </div>

        <template v-if="invitation.accepted">
          <div class="text-center">
            <div class="mb-4 text-green-600">
              <i class="pi pi-check-circle text-4xl"></i>
            </div>
            <h1 class="text-navy-800 mb-2 text-xl font-medium">
              Invitation Already Accepted
            </h1>
            <p class="text-navy-500 mb-6 text-sm">
              This invitation has already been used.
            </p>

            <a
              href="/session/new"
              class="text-sm text-green-600 hover:text-green-700"
            >
              Sign in to continue →
            </a>
          </div>
        </template>

        <template v-else-if="invitation.expired">
          <div class="text-center">
            <div class="mb-4 text-red-500">
              <i class="pi pi-times-circle text-4xl"></i>
            </div>
            <h1 class="text-navy-800 mb-2 text-xl font-medium">
              Invitation Expired
            </h1>
            <p class="text-navy-500 mb-6 text-sm">
              This invitation has expired. Please contact the person who invited
              you to request a new invitation.
            </p>
          </div>
        </template>

        <template v-else>
          <div class="text-center">
            <h1 class="text-navy-800 mb-2 text-xl font-medium">
              You've been invited!
            </h1>
            <p class="text-navy-500 mb-6 text-sm">
              <strong>{{ invitation.inviter_name }}</strong> has invited you to
              join <strong>{{ company.name }}</strong> as a
              {{ invitation.role }}.
            </p>

            <form @submit.prevent="accept">
              <button
                type="submit"
                :disabled="processing"
                class="flex w-full cursor-pointer items-center justify-center rounded-lg bg-green-500 px-4 py-3 font-medium text-white transition-colors hover:bg-green-600 disabled:cursor-not-allowed disabled:bg-green-300"
              >
                {{ processing ? "Accepting..." : "Accept Invitation" }}
              </button>
            </form>

            <p class="text-navy-400 mt-4 text-xs">
              You'll be asked to sign in or create an account.
            </p>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Head, router } from "@inertiajs/vue3"
import { ref } from "vue"

interface Props {
  invitation: {
    token: string
    email: string
    role: string
    inviter_name: string
    expired: boolean
    accepted: boolean
  }
  company: {
    name: string
  }
}

const props = defineProps<Props>()

const processing = ref(false)

const accept = () => {
  processing.value = true
  router.patch(`/invitations/${props.invitation.token}`)
}

defineOptions({ layout: false })
</script>
